/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ApiResponse } from '../../types/apiTypes';
import {
  VisitorSearch,
  VisitorSearchPayload,
} from '../../types/visitorSearchTypes';

export interface VisitorSearchState {
  visitors: ApiResponse<VisitorSearch>;
  visitorsToday: ApiResponse<VisitorSearch>;
  searchVisitorsLoading: boolean;
  searchVisitorsTodayLoading: boolean;
  error: string | null;
  lastSearchParams: VisitorSearchPayload;
}

const initialState: VisitorSearchState = {
  visitors: { data: [], meta: null, totalCount: 0, filteredCount: 0 },
  visitorsToday: { data: [], meta: null, totalCount: 0, filteredCount: 0 },
  searchVisitorsLoading: false,
  searchVisitorsTodayLoading: false,
  error: null,
  lastSearchParams: {},
};

type VisitorSearchLoadingKey =
  | 'searchVisitorsLoading'
  | 'searchVisitorsTodayLoading';

const visitorSearchSlice = createSlice({
  name: 'visitorSearch',
  initialState,
  reducers: {
    searchVisitors(
      state,
      _action: PayloadAction<VisitorSearchPayload & { orgId: number }>,
    ) {
      state.error = null;
    },
    searchVisitorsToday(state, _action: PayloadAction<{ orgId: number }>) {
      state.error = null;
    },

    setVisitors(state, action: PayloadAction<ApiResponse<VisitorSearch>>) {
      state.visitors = action.payload;
    },
    setVisitorsToday(state, action: PayloadAction<ApiResponse<VisitorSearch>>) {
      state.visitorsToday = action.payload;
    },
    setLastSearchParams(state, action: PayloadAction<VisitorSearchPayload>) {
      state.lastSearchParams = action.payload;
    },

    setLoading(
      state,
      action: PayloadAction<{ key: VisitorSearchLoadingKey; value: boolean }>,
    ) {
      state[action.payload.key] = action.payload.value;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
    clearVisitors(state) {
      state.visitors = initialState.visitors;
    },
    clearVisitorSearchState() {
      return initialState;
    },
  },
});

export const {
  searchVisitors,
  searchVisitorsToday,
  clearVisitors,
  clearVisitorSearchState,
} = visitorSearchSlice.actions;

export const visitorSearchActions = visitorSearchSlice.actions;
export default visitorSearchSlice.reducer;
